'use strict';

angular.module('myApp')


.controller('HeaderCtrl', ['$window','$location','$scope', '$timeout', '$rootScope',function($window, $location, $scope, $timeout, $rootScope) {



	

	
}])
